import React from "react"
import * as styles from "./Styles/CurrentBusinessHour.module.scss"
import { Place } from "../../types/place"
import Icon from "../../Utils/Icon"
import {
  BusinessHourSummary,
  BusinessHourType,
  BusinessHourTypeCode,
} from "../../Utils/business_hour_summary"

interface CurrentBHProps {
  place: Place
  businessHourSummary?: BusinessHourType
}

const CurrentBusinessHours: React.FC<CurrentBHProps> = (props) => {
  const summary =
    props.businessHourSummary || BusinessHourSummary.detect(props.place)
  return (
    <React.Fragment>
      {summary.code != undefined && (
        <Icon
          className={styles.clock}
          type="feather"
          name="clock"
          attr={{ width: 14, height: 14 }}
        />
      )}
      {summary.code == BusinessHourTypeCode.holiday && (
        <span className={styles.holiday}>定休日</span>
      )}
      {summary.code == BusinessHourTypeCode.opening && (
        <span className={styles.openTo}>{summary.text}</span>
      )}
      {summary.code == BusinessHourTypeCode.opened && (
        <span className={styles.closeTo}>{summary.text}</span>
      )}
      {summary.code == BusinessHourTypeCode.closed && (
        <span className={styles.closed}>営業終了</span>
      )}
      {summary.code == BusinessHourTypeCode.twentyfour && (
        <span className={styles.twentyfour}>24時間営業</span>
      )}
    </React.Fragment>
  )
}

export default CurrentBusinessHours
